import { Network } from '@capacitor/network'
import { acceptHMRUpdate, defineStore } from 'pinia'
import { computed, ref } from 'vue'

import mqtt from '@/sync/mqtt'

export const useStatusStore = defineStore('status', () => {
  const networkConnected = ref(false)
  const mqttConnected = ref(false)
  const syncConnected = ref(true)
  const hasTimeError = ref(false)

  Network.getStatus().then(status => {
    networkConnected.value = status.connected
  })

  Network.addListener('networkStatusChange', status => {
    networkConnected.value = status.connected
  })

  const isConnected = computed(() => {
    return mqttConnected.value && networkConnected.value && syncConnected.value
  })

  async function checkDeviceStatus() {
    mqttConnected.value = mqtt.isConnected()
  }

  function updateMqttStatus(connected: boolean) {
    mqttConnected.value = connected
  }

  function updateSyncStatus(connected: boolean) {
    syncConnected.value = connected
  }

  return {
    networkConnected,
    mqttConnected,
    syncConnected,
    hasTimeError,
    isConnected,
    checkDeviceStatus,
    updateMqttStatus,
    updateSyncStatus
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useStatusStore, import.meta.hot))
}
